export const FEATURES = {
  REGISTRATION_FAVORITES: 'registration.favorites',
  REGISTRATION_RENTALS: 'registration.rentals',
  REGISTRATION_MOST_VIEWED: 'registration.most_viewed',
  REGISTRATION: 'registration',
  ROKU_UNIVERSAL_SEARCH: 'roku.universal_search'
};
